export const iconFontAwesomeSpinnersSlash = (
	<i className="fa-solid fa-slash"></i>
);
